import React from 'react';

const HeroBanner = () => {
  const heroBanner = `${process.env.REACT_APP_ASSETS_URL}/Career/img-career-hero.svg`;

  return (
    <div className='flex items-center justify-center pb-20'>
      <img src={heroBanner} alt='Hero Banner' />
    </div>
  );
};

export default HeroBanner;
